import { render, staticRenderFns } from "./MultiBetItem.vue?vue&type=template&id=20539b4a&scoped=true&"
import script from "./MultiBetItem.vue?vue&type=script&lang=js&"
export * from "./MultiBetItem.vue?vue&type=script&lang=js&"
import style0 from "./MultiBetItem.vue?vue&type=style&index=0&id=20539b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20539b4a",
  null
  
)

export default component.exports